import { BETTERSTART_ASSET_HOST } from '@cli-constants/scaffolding.js'
import { findTopLevelProperty } from './find-top-level-property.js'

export function hasBetterStartImageHostConfigured(
  content: string,
  imagesObjectStart: number,
  imagesObjectEnd: number
): boolean {
  const domainsProp = findTopLevelProperty(content, imagesObjectStart, imagesObjectEnd, 'domains')
  if (domainsProp?.value.includes(BETTERSTART_ASSET_HOST)) {
    return true
  }

  const remotePatternsProp = findTopLevelProperty(
    content,
    imagesObjectStart,
    imagesObjectEnd,
    'remotePatterns'
  )
  return remotePatternsProp?.value.includes(BETTERSTART_ASSET_HOST) ?? false
}
